export const GENERAL_NOTE_MAX_LENGTH = 280;

export const getFormikInstanceRefProps = (setFormikRef) => ({ ref: setFormikRef });

export const getLoadedGeneralNote = (result) => {
  if (!result) {
    return null;
  }

  return result.note?.generalNoteToRenter || '';
};

export const isActiveGeneralNoteRequest = (requestKey, activeKey) => {
  return requestKey === activeKey;
};

export const getLoadedGeneralNoteForRequest = ({ result, requestKey, activeKey }) => {
  if (!isActiveGeneralNoteRequest(requestKey, activeKey)) {
    return null;
  }

  return getLoadedGeneralNote(result);
};

export const shouldClearGeneralNoteForIdentity = ({
  formikKey,
  activeKey,
  hasFormik,
}) => {
  return !!(hasFormik && formikKey !== activeKey);
};

export const shouldSeedLoadedGeneralNote = ({
  loadedGeneralNote,
  activeKey,
  hasFormik,
}) => {
  return !!(
    hasFormik &&
    loadedGeneralNote &&
    loadedGeneralNote.key === activeKey
  );
};

export const shouldPersistGeneralNote = ({ loadedGeneralNote, activeKey, seededKey }) => {
  return !!(
    loadedGeneralNote &&
    loadedGeneralNote.key === activeKey &&
    seededKey === activeKey
  );
};

export const isGeneralNoteInteractionDisabled = (generalNoteState) => {
  return !shouldPersistGeneralNote(generalNoteState);
};
